export enum PermissionType {
  Collaborator = 'collaborator',
  Viewer = 'viewer',
  Excluded = 'excluded',
  RemoveRule = 'removeRule',
  Owner = 'owner',
}
